<template>
  <div class="shopRating">
    <views-rating-stars :rating="rating"></views-rating-stars>
    <div class="shopRating__label">口コミ件数：{{ reviewCount }}件</div>
  </div>
</template>

<script>
import ViewsRatingStars from "./viewsRatingStars.vue";

export default {
  components: {
      'views-rating-stars': ViewsRatingStars
  },
  props: {
      rating: {
          type: Number,
          required: true
      },
      reviewCount: {
          type: Number,
          required: true
      }
  }
};
</script>
